import { styled } from 'styled-components';

import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { RETAILER_COLORS, SHADOWS } from '@components/web/src/styles';

export const HeaderWidgetContainer = styled(Flexbox)<{ $isCenteredLogo: boolean; $isAppInIframe: boolean }>`
  position: sticky;
  top: 0;
  z-index: 9999;
  height: 48px;
  background: ${RETAILER_COLORS.secondary['100']};
  align-items: center;
  box-shadow: ${SHADOWS.xs};
  padding: ${({ $isAppInIframe, $isCenteredLogo }) => {
    if ($isAppInIframe) return $isCenteredLogo ? '0 48px' : '0 48px 0 16px';
    return '0 16px';
  }};
  justify-content: ${({ $isCenteredLogo }) => ($isCenteredLogo ? 'center' : 'space-between')};
`;

export const LogoWrapper = styled.button`
  all: unset;
  height: 18px;
`;

export const MenuIconWrapper = styled(Flexbox)`
  width: 45px;
  height: 100%;
`;
